<template>
  <div class="wrapper">
    <hearder></hearder>
    <div class="main-container">
      <div class="home_bg" v-if="isShowBanner">
        <img src="../assets/banner.png" alt="" />
      </div>
      <div class="app-main">
        <div class="app-content">
          <router-view :key="key" />
        </div>
      </div>
    </div>
    <footer-index></footer-index>
  </div>
</template>
<script>
import Hearder from './components/hearder'
import FooterIndex from './components/footer'

export default {
  name: 'Layout',
  components: { Hearder, FooterIndex },
  data() {
    return {}
  },
  computed: {
    key() {
      return this.$route.fullPath
    },
    isShowBanner() {
      return this.$route.path == '/introduction' || this.$route.path == '/'
    }
  },
  methods: {}
}
</script>

<style lang="scss" scoped>
@import '@/styles/variables.scss';
.main-container {
  margin-top: 65px;
  min-height: calc(100vh - 117px);
}
.home_bg {
  text-align: center;
  img {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/layout/index.vue